export enum MedicalIdCondition {
  Required = "required",
  NotAccepted = "not_accepted",
  Optional = "optional",
}
